// @ts-strict-ignore
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconComponent } from '../../components/icon/icon.component';
import { GlobalIcon, GlobalIconSize } from '../../components/icon/icon.constants';

export type ExternalLink = { text: string; url: string };

@Component({
  selector: 'app-external-link',
  templateUrl: './external-link.component.html',
  styleUrls: ['./external-link.component.scss'],
  imports: [CommonModule, IconComponent],
})
export class ExternalLinkComponent implements OnInit {
  @Input() link: string;
  @Output() linkClicked: EventEmitter<void> = new EventEmitter<void>();

  ICON: GlobalIcon = GlobalIcon.ExternalLink;
  readonly ICON_SIZE = GlobalIconSize.Medium;

  ngOnInit(): void {
    if (this.link.startsWith('mailto:')) {
      this.ICON = GlobalIcon.Mail;
    }
  }
}
